import React from 'react';
import './DialogError.css';

import SlDialog from '@shoelace-style/shoelace/dist/react/dialog';
import { IoCloseCircleOutline, IoClose } from "react-icons/io5";

import { getLocale } from '../../locales/getLocale';


function DialogError ({ isOpen, setIsOpen }) {
    
    return (
        <SlDialog 
            open={isOpen} 
            noHeader={true}
            onSlRequestClose={() => setIsOpen(false)}
            className="dialog-error"
            style={{ color: 'var(--on-surface)' }}
        >

            <div className="banner">
                <IoCloseCircleOutline />
            </div>

            <div className='content'>
                <span className='title'>Documento non processato</span>
                <span>
                    Questa tipologia di documento potrebbe non essere supportata al momento.<br/>
                    Per assistenza, puoi contattare <a href={`mailto:${getLocale('SignUp.supportMail')}`}>{getLocale('SignUp.supportMail')}</a>
                </span>
            </div>

            <button className='close-button' onClick={() => {setIsOpen(false)}}>
                <IoClose />
                <span>Chiudi</span>
            </button>
        
        </SlDialog>
    );
};


export default DialogError;
